<template>
    <div class="row child-component">
      <div class="col-lg-7 col-md-8 col-sm-8 col-xs-6 mx-auto">
        <div class="">
          <div class="d-block row col-lg-8 mx-auto">
            <div class="col-12 fieldborder" style="margin-bottom: -22px !important">
              <slot name="label" class="lbltxt">
                <span class="lbltxt" style="margin-left: -2px; text-transform: uppercase">
                    Please select any other entity from the list below, where work will be performed against this client or where time will need to be recorded for this client?
                </span>
                <svg style="margin-bottom: 1px; margin-left: 5px" width="9px" height="9px" viewBox="0 0 9 9" version="1.1"
                  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                  v-b-tooltip.hover.v-dark.right.html="
                    'This client code will be opened in the Entity Specified in the first section of the request, as well as in the entity/entities checked off below (for Time entry purposes)'
                  ">
                  <g id="LATEST" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <path
                      d="M4.5,0 C2.014875,0 0,2.014875 0,4.5 C0,6.985125 2.014875,9 4.5,9 C6.985125,9 9,6.985125 9,4.5 C8.997375,2.016 6.984,0.002625 4.5,0 Z M4.59375,1.875 C4.90425,1.875 5.15625,2.127 5.15625,2.4375 C5.15625,2.748 4.90425,3 4.59375,3 C4.28325,3 4.03125,2.748 4.03125,2.4375 C4.03125,2.127 4.28325,1.875 4.59375,1.875 Z M5.4375,6.9375 L3.9375,6.9375 C3.7305,6.9375 3.5625,6.7695 3.5625,6.5625 C3.5625,6.3555 3.7305,6.1875 3.9375,6.1875 L4.21875,6.1875 C4.2705,6.1875 4.3125,6.1455 4.3125,6.09375 L4.3125,4.40625 C4.3125,4.3545 4.2705,4.3125 4.21875,4.3125 L3.9375,4.3125 C3.7305,4.3125 3.5625,4.1445 3.5625,3.9375 C3.5625,3.7305 3.7305,3.5625 3.9375,3.5625 L4.3125,3.5625 C4.726875,3.5625 5.0625,3.898125 5.0625,4.3125 L5.0625,6.09375 C5.0625,6.1455 5.1045,6.1875 5.15625,6.1875 L5.4375,6.1875 C5.6445,6.1875 5.8125,6.3555 5.8125,6.5625 C5.8125,6.7695 5.6445,6.9375 5.4375,6.9375 Z"
                      id="info" fill="#00A1D2" fill-rule="nonzero"></path>
                  </g>
                </svg>
              </slot>
              <div class="fieldborder" style="">
                <OmniSelect placeholder="Select Entity" :showLabel="false" v-model="ClientDetails.TimeEntryEntities" :options="OMDEntity" />
               </div>
            </div>
          </div>
        </div>
      </div>
      <div class="form-group pt-30 text-right footer-buttons">
        <button class="btn btn-link text-uppercase" @click="Cancel()">
          CANCEL
        </button>
        <button v-if="IsDraftVisible" class="text-uppercase btn btn-secondary btn-primary" @click="SaveasDraft()">
          SAVE FOR LATER
        </button>
         <button class="text-uppercase btn custom-button btn-primary" @click="Previous()">
          BACK
        </button>
        <button class="text-uppercase btn custom-button btn-primary" :disabled="$v.$invalid"
          @click="Next()">
          NEXT
        </button>
      </div>
      <br />
    </div>
  </template>
  <script>
  import store from "@/store";
  import { required } from "vuelidate/lib/validators";
  import { mapGetters } from "vuex";
  import service from "../../services/Dropdowns";
  export default {
    isdraftrequest: false,
    validations: {
      ClientDetails: {
        TimeEntryEntities: {
                required,
        },
      },
    },
    props: {
      id: {
        type: Number,
        required: false,
      },
      isDraft: {
        type: Boolean,
        required: false,
      },
    },
    beforeDestroy() {
      this.isdestroying = true;
    },

    mounted() {
      this.initiateStep();
      this.LoadDropdownValues();
    },
    activated() {
      this.initiateStep();
    },
    created() {
      this.initiateStep();
    },

    computed: {
      ...mapGetters("client", {
        ClientDetails: "ClientBasicDetails",
      }),
      IsEdit() {
        return this.id && !isNaN(this.id) && parseInt(this.id) > 0 ? true : false;
      },
      IsDraftVisible() {
        return this.id == null || this.id == 0 || this.isDraft == true;
      },
    },
    data() {
      return {
        OMDEntity: [],
        TimeEntry: {
            Entities: []
        },
        ClientDraftRequestId: 0,
      };
    },
    methods: {
      async LoadDropdownValues() {
        service.getOriginalEntityRecords("Financial Entity")
          .then((res) => {
            if (res.data && res.data.length) {
              this.OMDEntity = res.data;
              this.OMDEntity.forEach(element => { element.value = element.label; });
            }
          })
          .catch((err) => {
            alert(err);
          });
      },
      initiateStep() {
        this.$parent.$emit("stepInitiated", this.$route.meta.tabIndex);
      },
      NavigateToRoute(name) {
        if (this.id) {
          this.$router.push({
            name: `${name}`,
            params: { id: this.id, isDraft: this.isDraft },
          });
        } else {
          this.$router.push({ name: name });
        }
      },
      Next() {
        this.$parent.$emit("stepChanged", this.$route.meta.tabIndex);
        this.NavigateToRoute("Review");
      },
      SaveasDraft() {
        this.$store
          .dispatch("client/SaveClientDraft", this.isDraft == true ? parseInt(this.id) : null)
          .then((res) => {
            window.console.log(JSON.stringify(res));
            if (res.status == 200) {
                store.commit("progress/removeProcessing", {
                    root: true
                });
                //localStorage.setItem('clienticId','');
                store.dispatch(
                    "progress/setSuccessMessage",
                    `The Client request have been saved as Draft successfully`
                );

                this.$router.push("/ClientProduct");
            } else {
                window.console.log('error while uploading files');
            }
          })
          .catch((ex) => {
            if (ex.response && ex.response.status == 415 && ex.response.data) {
              store.dispatch("progress/setErrorMessage", `${ex.response.data}`);
            } else {
              this.$store.dispatch(
                "progress/setErrorMessage",
                `Error while Saving Client as Draft. ${ex}`
              );
            }
          });
      },
      Previous() {
        this.NavigateToRoute("Product Info");
      },
      Cancel() {
        this.RemoveFileLis = [];
        this.$router.push("/ClientProduct");
      },
    },
  };
  </script>

  <style scoped>
  .tooltip-inner {
    background-color: #2c3865 !important;
    color: white !important;
    max-width: 500px !important;
  }
  .tooltip {
    max-width: 500px !important;
  }
  .Text {
    width: 250px;
    height: 196px;
    font-family: "Open Sans";
    font-size: 10px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #ffffff;
  }
  .Text .text-style-1 {
    font-weight: 600;
  }
  .lbltxt {
    /* width: 300px; */
    height: 8px;
    font-family: "Open Sans";
    font-size: 11px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 0.8;
    letter-spacing: normal;
    color: #4d5161;
  }

  </style>